<section class="container py-2">
  <ng-container *ngIf="!current">
    <h1 class="h4">لیست عناوین مشاغل</h1>

    <h2 class="h5">لیست مشاغل بر اساس حروف الفبا</h2>
    <div class="d-flex flex-wrap">
      <a class="f-blue m-1 p-1" *ngFor="let char of alphabets" [routerLink]="['/browse', {a:char}]">{{char}}</a>
    </div>

    <h2 class="h5">عناوین شغلی {{params.a ? 'با حرف ' + params.a : 'پربازدید'}}</h2>
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let jobtitle of jobtitles">
        <a class="f-blue" [routerLink]="['/browse',{q:jobtitle.Title}]">{{jobtitle.Title}}</a>
        <p class="fs-sm" *ngIf="jobtitle.Brief">{{jobtitle.Brief}}</p>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="current">

    <h1 class="h4">{{current.Title}}</h1>
    <p class="fs-sm" *ngIf="current.Brief">{{current.Brief}}</p>
    <div>جستجو در آگهی‌های <a class="f-blue" [routerLink]="['/job',{q:current.Title}]">استخدام {{current.Title}}</a></div>
    <div *ngFor="let v of current.Variations">جستجو در آگهی‌های <a class="f-blue" [routerLink]="['/job',{q:v}]">استخدام {{v}}</a></div>
    
    <div class="d-md-flex justify-content-between">
      <div class="border-top mt-2 pt-2 px-2" *ngIf="jobSearch?.total">
        <h2 class="fs-normal fw-bold">آگهی‌های {{current.Title}}</h2>

        <div *ngFor="let job of jobSearch?.jobs">
          <app-job-summary [job]="job" mode="simple"></app-job-summary>
        </div>
      </div>
      <div>
        <div class="yellow-bg my-2 py-2 mx-0" [class.container-capped-sm]="!Utility.mobile" *ngIf="jobSearch?.total"
          [class.rounded-xl]="!Utility.mobile">
          <div class="px-2">
            تعداد <b class="fs-lg">{{jobSearch?.total}} آگهی استخدام
              {{current.Title}}</b> در کارپیشه پیدا کردیم.
            برای دیدن این آگهی‌ها و آگهی‌های بیشتر شهرت رو انتخاب کن و دکمه‌ی جستجو رو بزن.

            <div class="py-2">
              <app-location [accept-level]="2" name="location" placeholder="در کدام شهر سکونت دارید؟"
                [(ngModel)]="location"></app-location>
            </div>
            <div class="text-center">
              <a class="btn btn-blue mx-auto d-inline-block"
                [routerLink]="['/job',Utility.removeEmpty({q:current?.Title,l:Utility.locationSearch(location?.State, location?.City)})]">
                <b>جستجوی در همه آگهی‌های</b><br />
                <span class="fs-sm">{{current?.Title}} در {{Utility.locationSearch(location?.State, location?.City) ||
                  'سراسر کشور'}}</span>
              </a>

            </div>

          </div>
        </div>

      </div>

    </div>

  </ng-container>

  <ng-container *ngIf="!params.a">
    <h2 class="h5" *ngIf="!current">آگهی استخدام به تفکیک شهر و استان</h2>
    <h2 class="h5" *ngIf="current">استخدام {{current.Title}} به تفکیک شهر و استان</h2>
    <div class="row">
      <ng-container *ngFor="let location of locations">
        <a class="col-12 col-md-6 col-lg-4 col-xl-3 f-blue " *ngIf="!location.City"
          [routerLink]="['/browse',Utility.removeEmpty({q:current?.Title,l:location.State})]">
          <ng-container *ngIf="current">{{current.Title}} در </ng-container>
          استان {{location.State}}
        </a>
        <a *ngIf="location.City" class="col-12 col-md-6 col-lg-4 col-xl-3 f-blue"
          [routerLink]="['/job',Utility.removeEmpty({q:current?.Title,l:Utility.locationSearch(location.State, location.City)})]">
          <ng-container *ngIf="current">{{current.Title}} در </ng-container>
          {{location.City}}
        </a>
      </ng-container>
    </div>
  </ng-container>
  <a class="py-2 fw-bold f-blue" routerLink="/browse">
    بازگشت به لیست عناوین مشاغل
  </a>

  <!-- 
List of Letters
> ;a={letter}

Top job titles
> /job?q={jobtitle}

List of provinces
> /browser;l={province}
list of cities
> /browser;l={province},{city}
top jobtitles
> /job?l=l={province},{city}q={jobtitle}
top jobtitles -->
</section>